import * as React from 'react';
import { Component } from 'react';
import styles from '../styles/containers/LeftBar.scss';
import LogoIcon from '../assets/images/logo-50x50.svg';
import ProjectsIcon from '../assets/images/projects-24-24.svg';
import ProjectSettingsIcon from '../assets/images/project-settings-24x24.svg';
import PlansIcon from '../assets/images/plans-20x20.svg';
import TasksIcon from '../assets/images/tasks-20x20.svg';
import HelpIcon from '../assets/images/help-24x24.svg';
import BookCompaniesUsersIcon from '../assets/images/book-companies-users-20x20.svg';
import DocumentsIcon from '../assets/images/documents-24x24.svg';
import BOQIcon from '../assets/images/boq-24x24.svg';
import TenderIcon from '../assets/images/tender-24x24.svg';
import MeetingsIcon from '../assets/images/meetings-24x24.svg';
import SpaceAllocationIcon from '../assets/images/space-allocation-24x24.svg';
import ProductsIcon from '../assets/images/products-24x24.svg';
import SpecificationsIcon from '../assets/images/specifications-24x24.svg';
import SuperadminIcon from '../assets/images/superadmin-24x24.svg';
import SharedWithMeIcon from '../assets/images/shared-with-me.svg';
import { withRouter } from 'react-router';
import classNames from 'classnames';
import {
  __,
  app_env,
  getActiveProject,
  getActiveStage,
  redirect,
} from '../core/utils';
import { connect } from 'react-redux';
import Tooltip from '../components/Tooltip';
import TimesheetIcon from '../assets/images/timesheet-icon-clock.svg';
import {
  createSidebar,
  getSuperadminSidebarModule,
  redirectToSidebarSubmodule,
} from '../redux/actions/general/sidebar';

const mapStateToProps = (state) => {
  return {
    active_modules: state.general.active_modules,
    projects: state.table['all_projects'],
    auth: state.auth,
  };
};

const createStaticLink = (link) => () => link;

const createProjectLink = (projectId, suffix) => {
  return projectId ? () => `/projects/${projectId}${suffix}` : null;
};

const createStageLink = (stageId, suffix) => {
  return stageId ? () => `/stages/${stageId}${suffix}` : null;
};

const createImportLink = (stageId) => {
  return stageId ? () => `/import/${stageId}` : null;
};

const createSidebarItems = (links) => {
  return _.compact(links).map((link) => ({ link }));
};

const createSidebarModule = (title, moduleKey, items, fallbackLink) => {
  return {
    title,
    moduleKey,
    items,
    fallbackLink,
  };
};

const getLeftBarSidebarModules = ({ activeProject, activeStage }) => {
  return {
    projects: createSidebarModule(
      __('submenu.title.projects'),
      'projects',
      createSidebarItems([
        createStaticLink('/projects'),
        createStaticLink('/projects/shared'),
      ]),
      '/projects'
    ),
    project_settings: createSidebarModule(
      __('submenu.title.project'),
      'project_settings',
      createSidebarItems([
        createProjectLink(activeProject, '/general'),
        createProjectLink(activeProject, '/project-planning'),
        createStageLink(activeStage, '/teams'),
        createProjectLink(activeProject, '/stages'),
        createStageLink(activeStage, '/approvers'),
        createImportLink(activeStage),
      ]),
      activeProject
        ? `/projects/${activeProject}/stages`
        : activeStage
        ? `/stages/${activeStage}/teams`
        : null
    ),
    plans: createSidebarModule(
      __('submenu.title.plans'),
      'plans',
      createSidebarItems([
        createStageLink(activeStage, '/plans/current'),
        createStageLink(activeStage, '/plans/working'),
        createStageLink(activeStage, '/plans/uploads'),
        createStageLink(activeStage, '/ocr_templates'),
        createStageLink(activeStage, '/plan_setting_templates'),
        createStageLink(activeStage, '/deliveries/my'),
        createStageLink(activeStage, '/deliveries'),
        createStageLink(activeStage, '/approvals'),
      ]),
      activeStage ? `/stages/${activeStage}/plans/current` : null
    ),
    meetings: createSidebarModule(
      __('submenu.title.meetings'),
      'meetings',
      createSidebarItems([createStageLink(activeStage, '/meetings')]),
      activeStage ? `/stages/${activeStage}/meetings` : null
    ),
    tasks: createSidebarModule(
      __('submenu.title.tasks'),
      'tasks',
      createSidebarItems([createStageLink(activeStage, '/tasks')]),
      activeStage ? `/stages/${activeStage}/tasks` : null
    ),
    products: createSidebarModule(
      __('submenu.title.products'),
      'products',
      createSidebarItems([
        createStaticLink('/products?filter.subgroup='),
        createStaticLink('/products/public_brands'),
      ]),
      '/products?filter.subgroup='
    ),
    specifications: createSidebarModule(
      __('submenu.title.specifications'),
      'specifications',
      createSidebarItems([
        createStageLink(activeStage, '/specifications/current'),
        createStageLink(activeStage, '/specifications/working'),
        createStageLink(activeStage, '/specifications/sets'),
        createStageLink(activeStage, '/specification_deliveries/my'),
        createStageLink(activeStage, '/specification_deliveries'),
        createStageLink(activeStage, '/specification_approvals'),
      ]),
      activeStage ? `/stages/${activeStage}/specifications/current` : null
    ),
    boq: createSidebarModule(
      __('submenu.title.bill-of-quantities'),
      'boq',
      createSidebarItems([
        createStageLink(activeStage, '/boq/working?filter.subgroup='),
        createStageLink(activeStage, '/boq/import'),
      ]),
      activeStage ? `/stages/${activeStage}/boq/working?filter.subgroup=` : null
    ),
    tenders: createSidebarModule(
      __('submenu.title.tenders'),
      'tenders',
      createSidebarItems([createStageLink(activeStage, '/tenders')]),
      activeStage ? `/stages/${activeStage}/tenders` : null
    ),
    space_allocation: createSidebarModule(
      __('submenu.title.space-allocation'),
      'space_allocation',
      createSidebarItems([
        createStageLink(activeStage, '/space_allocation/rooms'),
        createStageLink(activeStage, '/space_allocation/room_types'),
        createStageLink(activeStage, '/space_allocation/room_groups'),
        createStageLink(activeStage, '/space_allocation/zones'),
        createStageLink(activeStage, '/space_allocation/entrances'),
        createStageLink(activeStage, '/space_allocation/expansion_joints'),
        createStageLink(activeStage, '/space_allocation/storeys'),
        createStageLink(activeStage, '/space_allocation/buildings'),
        createStageLink(activeStage, '/space_allocation/sites'),
      ]),
      activeStage ? `/stages/${activeStage}/space_allocation/rooms` : null
    ),
    timesheets: createSidebarModule(
      __('submenu.title.time-log-main'),
      'timesheets',
      createSidebarItems([
        createStaticLink('/timesheets'),
        createStaticLink('/timesheet_report'),
        createStaticLink('/timesheet_entries'),
      ]),
      '/timesheets'
    ),
    companies_and_users: createSidebarModule(
      __('companies-and-users.title.companies-&-users'),
      'companies_and_users',
      createSidebarItems([
        createStaticLink('/companies'),
        createStaticLink('/companies/partner'),
        createStaticLink('/companies/partner_members'),
        createStaticLink('/companies/my/members'),
        createStaticLink('/address_book/companies'),
        createStaticLink('/address_book/contacts'),
      ]),
      '/companies/my/members'
    ),
    shared_with_me: createSidebarModule(
      __('submenu.title.all-shared-models'),
      'shared_with_me',
      createSidebarItems([createStaticLink('/shared_with_me')]),
      '/shared_with_me'
    ),
  };
};

@connect(mapStateToProps, null)
@withRouter
class LeftBar extends Component {
  constructor(props) {
    super(props);
  }

  _prepareSidebar(module) {
    createSidebar({
      title: module.title,
      items: [],
    });
  }

  _redirectToSidebarModule(module) {
    this._prepareSidebar(module);

    return redirectToSidebarSubmodule(module);
  }

  matches(paths) {
    return _.includes(paths, this.props.match.path);
  }

  render() {
    const active_stage = getActiveStage();
    const { auth } = this.props;
    const company = !_.isEmpty(auth.company);
    const active_project_from_modules = _.get(
      _.find(_.get(this.props.active_modules, 'items', []), (project) =>
        _.find(project.stages, ['id', active_stage])
      ),
      'id'
    );
    const active_project = getActiveProject() || active_project_from_modules;
    const sidebarModules = getLeftBarSidebarModules({
      activeProject: active_project,
      activeStage: active_stage,
    });
    const superadminSidebarModule = auth.superadmin
      ? getSuperadminSidebarModule({
          superadmin: auth.superadmin,
        })
      : null;
    const superadminPaths = _.map(
      _.get(superadminSidebarModule, 'items', []),
      (item) => item.link()
    );

    return (
      <div className={styles.wrapper}>
        <Tooltip placement='right' text={__('mainmenu.tooltip.dashboard')}>
          <LogoIcon
            className={classNames(
              styles.logo,
              app_env == 'development' && styles.dev,
              app_env == 'local' && styles.local
            )}
            onClick={() => redirect('/')}
          />
        </Tooltip>
        <div className={styles.menu}>
          <Tooltip placement='right' text={__('mainmenu.tooltip.projects')}>
            <ProjectsIcon
              className={classNames(
                this.matches(['/(projects)?', '/projects/shared']) &&
                  styles.active,
                !company && styles.disabled
              )}
              onClick={() =>
                company &&
                this._redirectToSidebarModule(sidebarModules.projects)
              }
            />
          </Tooltip>
          <Tooltip
            placement='right'
            text={__('mainmenu.tooltip.active-project-settings')}
          >
            <ProjectSettingsIcon
              className={classNames(
                this.matches([
                  '/projects/:project/stages',
                  '/stages/:stage/approvers',
                  '/stages/:stage/teams',
                  '/projects/:project/general',
                  '/projects/:project/financial',
                  '/projects/:project/project-planning',
                  '/import/:stage',
                ]) && styles.active,
                (!active_stage || !company) && styles.disabled
              )}
              onClick={() => {
                if (!company) {
                  return;
                }

                return this._redirectToSidebarModule(
                  sidebarModules.project_settings
                );
              }}
            />
          </Tooltip>
          <Tooltip placement='right' text={__('mainmenu.tooltip.meetings')}>
            <MeetingsIcon
              className={classNames(
                this.matches([
                  '/stages/:stage/meetings',
                  '/meetings/:meeting',
                ]) && styles.active,
                (!active_stage || !company) && styles.disabled
              )}
              onClick={() =>
                active_stage &&
                company &&
                this._redirectToSidebarModule(sidebarModules.meetings)
              }
            />
          </Tooltip>
          <Tooltip placement='right' text={__('mainmenu.tooltip.tasks')}>
            <TasksIcon
              className={classNames(
                this.matches(['/stages/:stage/tasks']) && styles.active,
                (!active_stage || !company) && styles.disabled
              )}
              onClick={() =>
                active_stage &&
                company &&
                this._redirectToSidebarModule(sidebarModules.tasks)
              }
            />
          </Tooltip>
          <Tooltip placement='right' text={__('mainmenu.tooltip.plans')}>
            <PlansIcon
              className={classNames(
                this.matches([
                  '/stages/:stage/plans/uploads',
                  '/stages/:stage/ocr_templates',
                  '/ocr_templates/:ocr_template',
                  '/stages/:stage/plan_setting_templates',
                  '/stages/:stage/plans/working',
                  '/plans/versions/:plan_version',
                  '/stages/:stage/deliveries/my',
                  '/stages/:stage/deliveries',
                  '/stages/:stage/deliveries/:type(my|public)/:delivery',
                  '/stages/:stage/approvals/:status(pending|approved|rejected)?',
                  '/stages/:stage/plans/current',
                  '/plans/revisions/:plan_revision',
                ]) && styles.active,
                (!active_stage || !company) && styles.disabled
              )}
              onClick={() =>
                active_stage &&
                company &&
                this._redirectToSidebarModule(sidebarModules.plans)
              }
            />
          </Tooltip>
          <Tooltip placement='right' text={__('mainmenu.tooltip.products')}>
            <ProductsIcon
              className={classNames(
                this.matches(['/products', '/products/public_brands']) &&
                  styles.active,
                !company && styles.disabled
              )}
              onClick={() =>
                company &&
                this._redirectToSidebarModule(sidebarModules.products)
              }
            />
          </Tooltip>
          <Tooltip
            placement='right'
            text={__('mainmenu.tooltip.specifications')}
          >
            <SpecificationsIcon
              className={classNames(
                this.matches([
                  '/stages/:stage/specifications/working',
                  '/stages/:stage/specifications/current',
                  '/stages/:stage/specifications/sets',
                  '/stages/:stage/specifications/sets/:specification_set',
                  '/stages/:stage/specification_deliveries/my',
                  '/stages/:stage/specification_deliveries',
                  '/stages/:stage/specification_deliveries/:type(my|public)/:specification_delivery',
                  '/stages/:stage/specification_approvals/:status(pending|approved|rejected)?',
                ]) && styles.active,
                (!active_stage || !company) && styles.disabled
              )}
              onClick={() =>
                active_stage &&
                company &&
                this._redirectToSidebarModule(sidebarModules.specifications)
              }
            />
          </Tooltip>
          <Tooltip
            placement='right'
            text={__('mainmenu.tooltip.bill-of-quantities')}
          >
            <BOQIcon
              className={classNames(
                this.matches([
                  '/stages/:stage/boq/working',
                  '/stages/:stage/boq/import',
                ]) && styles.active,
                (!active_stage || !company) && styles.disabled
              )}
              onClick={() =>
                active_stage &&
                company &&
                this._redirectToSidebarModule(sidebarModules.boq)
              }
            />
          </Tooltip>
          <Tooltip placement='right' text={__('mainmenu.tooltip.tenders')}>
            <TenderIcon
              className={classNames(
                this.matches([
                  '/stages/:stage/tenders',
                  '/stages/:stage/tenders/:tender/boq',
                ]) && styles.active,
                (!active_stage || !company) && styles.disabled
              )}
              onClick={() =>
                active_stage &&
                company &&
                this._redirectToSidebarModule(sidebarModules.tenders)
              }
            />
          </Tooltip>
          <Tooltip
            placement='right'
            text={__('mainmenu.tooltip.space-allocation')}
          >
            <SpaceAllocationIcon
              className={classNames(
                this.matches([
                  '/stages/:stage/space_allocation/sites',
                  '/stages/:stage/space_allocation/buildings',
                  '/stages/:stage/space_allocation/storeys',
                  '/stages/:stage/space_allocation/zones',
                  '/stages/:stage/space_allocation/expansion_joints',
                  '/stages/:stage/space_allocation/entrances',
                  '/stages/:stage/space_allocation/rooms',
                  '/stages/:stage/space_allocation/room_groups',
                  '/stages/:stage/space_allocation/room_types',
                ]) && styles.active,
                (!active_stage || !company) && styles.disabled
              )}
              onClick={() =>
                active_stage &&
                company &&
                this._redirectToSidebarModule(sidebarModules.space_allocation)
              }
            />
          </Tooltip>
          {/* <Tooltip placement='right' text={__('mainmenu.tooltip.documents')}>
            <DocumentsIcon
              className={classNames(
                this.matches(['/stages/:stage/documents']) && styles.active,
                (!active_stage || !company) && styles.disabled
              )}
              onClick={() =>
                active_stage &&
                company &&
                redirect('/stages/' + active_stage + '/documents')
              }
            />
          </Tooltip> */}
          <Tooltip placement='right' text={__('mainmenu.tooltip.time')}>
            <TimesheetIcon
              className={classNames(
                this.matches([
                  '/timesheets',
                  '/timesheet_report',
                  '/timesheet_entries',
                ]) &&
                styles.active,
                !company && styles.disabled
              )}
              onClick={() =>
                company &&
                this._redirectToSidebarModule(sidebarModules.timesheets)
              }
            />
          </Tooltip>
          <Tooltip
            placement='right'
            text={__('mainmenu.tooltip.companies-and-users')}
          >
            <BookCompaniesUsersIcon
              className={classNames(
                this.matches([
                  '/companies',
                  '/companies/partner',
                  '/companies/partner_members',
                  '/companies/my/members',
                  '/address_book/companies',
                  '/address_book/contacts',
                ]) && styles.active,
                !company && styles.disabled
              )}
              onClick={() =>
                company &&
                this._redirectToSidebarModule(
                  sidebarModules.companies_and_users
                )
              }
            />
          </Tooltip>

          <Tooltip
            placement='right'
            text={__('mainmenu.tooltip.shared_with_me')}
          >
            <SharedWithMeIcon
              className={classNames(
                this.matches(['/shared_with_me']) && styles.active
              )}
              onClick={() =>
                this._redirectToSidebarModule(sidebarModules.shared_with_me)
              }
            />
          </Tooltip>
          {auth.superadmin && (
            <Tooltip placement='right' text={__('mainmenu.tooltip.superadmin')}>
              <SuperadminIcon
                className={classNames(
                  this.matches(superadminPaths) && styles.active
                )}
                onClick={() =>
                  superadminSidebarModule &&
                  this._redirectToSidebarModule(superadminSidebarModule)
                }
              />
            </Tooltip>
          )}
        </div>
        <div className={styles.info}>{__('mainmenu.help')}</div>
        <div className={styles.separator} />
        <Tooltip placement='right' text={__('mainmenu.tooltip.help')}>
          <a href='https://volum3.com/en/help/' target='_blank'>
            <HelpIcon className={styles.bug} />
          </a>
        </Tooltip>
      </div>
    );
  }
}

export default LeftBar;
